import React from "react";
import styles from "./doc-set.module.scss";
import { Link } from "gatsby";

const DocSet = ({ icon, text, link }) => {
  return (
    <li className={styles.docContainer}>
      <Link to={link}>
          <h3>{text}</h3>
      </Link>
    </li>
  );
};

export default DocSet;